"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const gridHeight = {
    height: 'calc(100vh - 475px)'
};
const gridHeightDeletedList = {
    height: 'calc(100vh - 480px)',
    marginBottom: 20
};
const modalUploadManual = theme => ({
    padding: 24,
    width: 'fit-content',
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const modalUploadSurvey = theme => ({
    padding: 24,
    width: 'fit-content',
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const modalContainerDeletedReason = theme => ({
    width: 432,
    height: 260,
    padding: 24,
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const modalContainerDeletedList = theme => ({
    width: 1227,
    height: 586,
    padding: 24,
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const modalConfirmContainer = theme => ({
    padding: 24,
    width: 556,
    height: 339,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white
});
const modalHistoryContainer = theme => ({
    width: 1150,
    padding: 24,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white
});
const modalContainerUpdate = theme => ({
    padding: 24,
    height: 'auto',
    width: 'fit-content',
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const modalHeader = {
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: 'bold',
    alignItems: 'center',
    marginBottom: 24
};
const itemAdd = {
    columnGap: 12,
    display: 'grid',
    marginBottom: 24,
    alignItems: 'center',
    gridTemplateColumns: '130px 225px',
};
const inputItem = {
    height: 30,
    padding: 10,
    width: '100%',
    borderRadius: 5,
    border: '1px solid #DEE0E5'
};
const textAreaItem = {
    padding: 10,
    width: '100%',
    borderRadius: 5,
    border: '1px solid #DEE0E5'
};
const buttonSave = backgroundColor => ({
    height: 40,
    padding: '0',
    width: '15%',
    display: 'flex',
    borderRadius: 8,
    fontSize: 'large',
    color: constants_1.color.white,
    fontWeight: 'normal',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: backgroundColor,
});
const buttonDelete = {
    padding: '0 5px',
    display: 'flex',
    fontSize: 'large',
    fontWeight: 'normal',
    justifyContent: 'space-around',
    alignItems: 'center',
    color: constants_1.color.white,
    backgroundColor: constants_1.color.redDark,
    height: 35,
    width: 65,
    borderRadius: 10
};
const modalTitle = {
    margin: 0,
    fontSize: 20,
    lineHeight: '30px',
};
const modalSubtitle = {
    margin: 0,
    fontWeight: 400,
    lineHeight: '24px',
    color: constants_1.color.softGrey,
};
const dropdownStyle = theme => ({
    width: '100%',
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    borderColor: theme === 'dark' ? constants_1.color.white : constants_1.color.borderGrey,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const gridCard = theme => ({
    padding: 24,
    borderRadius: 10,
    boxShadow: '1px 2px 8px 0px #006D901A',
    backgroundColor: theme === 'dark' ? constants_1.color.gridColumnDarkAlt : constants_1.color.white,
});
const dateButtonWrapper = {
    display: 'flex',
    marginBottom: 24,
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'space-between',
};
const textDate = theme => ({
    margin: 0,
    fontSize: 14,
    fontWeight: 400,
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
});
const button = (color) => ({
    height: 40,
    display: 'flex',
    borderRadius: 8,
    width: 'fit-content',
    padding: '12px 20px',
    alignItems: 'center',
    backgroundColor: color,
});
const buttonTitle = {
    margin: 0,
    fontSize: 16,
    marginLeft: 8,
    fontWeight: '500',
    lineHeight: '24px'
};
const legendList = {
    margin: 0,
    padding: 0,
    display: 'flex',
    listStyleType: 'none',
};
const legendItem = theme => ({
    marginRight: 12,
    display: 'flex',
    alignItems: 'center',
    color: theme === 'light' ? 'inherit' : constants_1.color.white,
});
const listGrey = {
    width: 24,
    height: 24,
    marginRight: 8,
    borderRadius: 5,
    backgroundColor: '#4C8C8C'
};
const listRed = {
    width: 24,
    height: 24,
    marginRight: 8,
    borderRadius: 5,
    backgroundColor: '#EA0927'
};
const summaryDataContainer = {
    columnGap: 24,
    display: 'grid',
    marginBottom: 24,
    gridTemplateColumns: 'repeat(2, 1fr)'
};
const summaryDataTitle = {
    margin: 0,
    fontSize: 12,
    marginBottom: 12,
    lineHeight: '18px',
    color: constants_1.color.lightGray,
};
const summaryDataCardWrapper = {
    columnGap: 12,
    maxWidth: 748,
    display: 'grid',
    overflowX: 'auto',
    paddingBottom: 12,
    overflowY: 'hidden',
    gridTemplateColumns: '140px 140px 140px 140px 140px'
};
const summaryDataPills = type => ({
    display: 'flex',
    borderRadius: 8,
    color: constants_1.color.white,
    padding: '8px 18px',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: type === 'trip' ? '#4C8C8C' : '#525252'
});
const summaryDataPillsLabel = {
    margin: 0,
    fontSize: 16,
    marginRight: 8,
    fontWeight: 500,
    lineHeight: '24px',
};
const summaryDataPillsValue = type => ({
    margin: 0,
    fontSize: 20,
    fontWeight: 700,
    color: type === 'trip' ? '#5AF8C5' : '#FFFFFF',
    lineHeight: '30px',
});
const posButton = {
    margin: 0,
    width: 110,
    padding: 16,
    fontSize: 24,
    fontWeight: 600,
    borderRadius: 10,
    marginBottom: 24,
    lineHeight: '22px',
    backgroundColor: '#4C8C8C'
};
const posLabel = {
    margin: 0,
    fontSize: 24,
    lineHeight: '24px',
    color: constants_1.color.white,
    textAlign: 'center',
};
const modalFormUpdateContainer = {
    columnGap: 24,
    display: 'grid',
    gridTemplateColumns: 'auto auto',
};
const modalButtonContainer = {
    columnGap: 12,
    display: 'flex',
};
const customListDropdown = duplicated => ({
    width: 16,
    height: 16,
    marginRight: 8,
    borderRadius: 4,
    backgroundColor: duplicated === 'Duplicated' ? constants_1.color.redDark : '#4C8C8C',
});
const modalContainerMutation = (theme) => ({
    width: 'fit-content',
    minWidth: 800,
    padding: 24,
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const inputWrapper = {
    columnGap: 12,
    display: 'grid',
    marginBottom: 12,
    alignItems: 'center',
    gridTemplateColumns: '130px 225px',
};
exports.default = {
    button,
    itemAdd,
    listRed,
    listGrey,
    textDate,
    gridCard,
    posLabel,
    posButton,
    inputItem,
    gridHeight,
    modalTitle,
    buttonSave,
    legendList,
    legendItem,
    buttonTitle,
    modalHeader,
    buttonDelete,
    inputWrapper,
    textAreaItem,
    modalSubtitle,
    dropdownStyle,
    summaryDataPills,
    modalUploadManual,
    modalUploadSurvey,
    summaryDataTitle,
    dateButtonWrapper,
    customListDropdown,
    summaryDataContainer,
    modalButtonContainer,
    modalContainerUpdate,
    gridHeightDeletedList,
    modalConfirmContainer,
    modalHistoryContainer,
    summaryDataPillsLabel,
    summaryDataPillsValue,
    modalContainerMutation,
    summaryDataCardWrapper,
    modalFormUpdateContainer,
    modalContainerDeletedList,
    modalContainerDeletedReason,
};
